export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热门推荐', href: '#carousel' },
  { label: '平台优势', href: '#features' },
  { label: '用户口碑', href: '#comments' },
  { label: '关于我们', href: '#about' },
];

export const heroStats = [
  { value: '每日更新 200+', label: '高清资源' },
  { value: '覆盖 30+', label: '内容分类' },
  { value: '全平台兼容', label: '手机/电脑/平板' },
];

export const appEntry = {
  title: '91免费手机版',
  subtitle: '随时随地，畅享免费看片体验',
  description: '支持 iOS 与 Android 双平台，适配手机与平板屏幕，极速加载、流畅播放。无需安装复杂软件，浏览器打开即可使用91免费看片神器，走到哪里看到哪里。',
  features: ['高清流畅播放', '智能记忆进度', '夜间模式护眼', '一键分享好友'],
  imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20smartphone%20displaying%20movie%20streaming%20interface%20with%20film%20posters%20on%20screen%2C%20held%20in%20hand%20against%20warm%20dark%20theater%20background%2C%20soft%20ambient%20red%20and%20gold%20lighting%2C%20elegant%20product%20photography%2C%20clean%20minimal%20composition%2C%20modern%20tech%20aesthetic&width=600&height=500&seq=app-entry-01&orientation=squarish',
};

export const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量片库每日更新',
    description: '聚合全网免费看片资源，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，每日新增超200部高清内容，确保您永远有片可看。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全无广告体验',
    description: '91免费平台严格过滤恶意弹窗与诱导链接，提供纯净观影环境。无需注册、无需付费，打开即看，保护您的隐私与设备安全。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速加载流畅播放',
    description: '采用智能CDN加速与自适应码率技术，无论宽带还是移动网络均可秒开播放，支持1080P全高清画质，告别卡顿与缓冲。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全终端无缝适配',
    description: '完美兼容手机、平板、电脑等各类设备，自动适配屏幕尺寸与分辨率。支持投屏到电视大屏，享受家庭影院级观影体验。',
  },
  {
    icon: 'ri-search-eye-line',
    title: '智能搜索精准推荐',
    description: '基于观影偏好与热门趋势的智能推荐引擎，帮您快速找到想看的内容。支持多维度筛选，按类型、年份、地区、评分精准定位。',
  },
];

export const carouselItems = [
  {
    title: '2026暑期档热片合集',
    category: '电影精选',
    description: '汇集本年度暑期最受关注的院线大片与热门新片，涵盖动作、喜剧、科幻等多种类型，一站式满足您的夏日观影需求。',
    tag: '爆款推荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20and%20crimson%20tones%2C%20film%20reels%20and%20projector%20light%20beams%2C%20dramatic%20lighting%2C%20vintage%20cinema%20aesthetic%2C%20warm%20atmospheric%20glow%2C%20art%20deco%20patterns%2C%20no%20text%2C%20abstract%20cinematic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '高分华语剧集连播',
    category: '剧集专场',
    description: '精选豆瓣8.0以上华语口碑剧集，从经典老剧到当季新番，悬疑探案、都市情感、古装传奇各类题材一网打尽，追剧不等待。',
    tag: '口碑之选',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20with%20traditional%20Chinese%20architectural%20elements%20and%20modern%20film%20aesthetic%2C%20soft%20golden%20and%20amber%20lighting%2C%20elegant%20composition%20with%20lantern%20glow%2C%20dramatic%20shadows%2C%20rich%20texture%2C%20no%20people%2C%20atmospheric%20mood&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '日韩热门番剧追更',
    category: '动漫专区',
    description: '同步更新当季热门日韩动漫番剧，包含热血战斗、治愈日常、悬疑推理等多种风格，中文字幕及时跟进，追番党不可错过的宝藏合集。',
    tag: '追番必备',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20anime-style%20cinematic%20illustration%20with%20warm%20golden%20and%20red%20tones%2C%20dynamic%20composition%20with%20flowing%20energy%20lines%2C%20stylized%20Japanese%20aesthetic%2C%20cherry%20blossom%20petals%2C%20dramatic%20lighting%2C%20no%20characters%2C%20abstract%20artistic%20background&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '经典好莱坞大片回顾',
    category: '海外佳片',
    description: '重温影史经典之作，从奥斯卡获奖影片到IMDb高分神作，精心整理中英双语版本，让您在91免费平台感受世界级电影艺术的魅力。',
    tag: '经典珍藏',
    imageUrl: 'https://readdy.ai/api/search-image?query=Classic%20Hollywood%20cinematic%20aesthetic%20with%20warm%20vintage%20golden%20tones%2C%20film%20noir%20inspired%20lighting%2C%20old%20Hollywood%20glamour%20texture%2C%20dramatic%20spotlight%20beams%2C%20art%20deco%20geometric%20patterns%2C%20rich%20sepia%20and%20gold%20color%20palette%2C%20no%20people&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '热门综艺全集放送',
    category: '综艺合集',
    description: '汇聚国内外热门综艺节目，音乐竞演、真人秀、脱口秀、旅行节目应有尽有，更新及时不掉队，轻松追综不费力。',
    tag: '综艺盛宴',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20stage%20performance%20scene%20with%20warm%20colorful%20spotlights%20and%20dynamic%20stage%20design%2C%20concert%20atmosphere%2C%20golden%20and%20amber%20lighting%20effects%2C%20abstract%20entertainment%20show%20aesthetic%2C%20no%20performers%20visible%2C%20dramatic%20composition&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const faqItems = [
  {
    question: '91免费看片网站真的完全免费吗？',
    answer: '是的，91免费平台对所有用户完全免费开放。我们通过聚合公开网络资源和优化运营成本，实现零门槛观影体验。您无需支付任何费用、无需购买会员，即可浏览和观看平台上所有内容。我们始终坚持"免费看片"的核心理念。',
  },
  {
    question: '是否需要注册账号才能观看？',
    answer: '不需要。91免费看片网站采用免注册设计，打开浏览器即可直接搜索和观看您感兴趣的内容。我们尊重用户隐私，不强制收集个人信息。但如果您希望使用收藏、历史记录等个性化功能，可选择自愿注册。',
  },
  {
    question: '支持哪些设备观看？画质如何？',
    answer: '91免费平台全面兼容手机（iOS/Android）、平板和电脑端，自动适配屏幕尺寸。视频画质从流畅到1080P全高清可选，系统会根据您的网络状况智能推荐最佳清晰度。同时支持投屏功能，可将内容投射到智能电视上享受大屏观影。',
  },
  {
    question: '91免费看片神器是什么？怎么使用？',
    answer: '91免费看片神器是我们为移动端用户优化的快捷观影工具。只需在手机浏览器中打开91免费网站，系统会自动适配移动端界面，提供触屏优化的播放控制和导航体验。无需下载安装任何APP，添加到手机桌面即可像原生应用一样使用。',
  },
  {
    question: '内容更新频率如何？能找到最新影视吗？',
    answer: '91免费平台保持高频率内容更新，平均每日新增超过200部高清资源。热门影视剧集在上线后24小时内即可在平台找到，综艺节目和动漫番剧同步跟进更新。我们建立了智能抓取与人工审核相结合的内容更新机制，确保时效性与质量。',
  },
];

export const cards = [
  {
    title: '动作冒险',
    icon: 'ri-fire-line',
    description: '肾上腺素飙升的视觉盛宴',
    count: '2,860+ 部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20action%20movie%20aesthetic%20with%20dramatic%20explosion%20effects%20in%20warm%20orange%20and%20gold%20tones%2C%20dynamic%20motion%20blur%2C%20intense%20atmosphere%2C%20film%20grain%20texture%2C%20no%20people%2C%20abstract%20cinematic%20composition&width=600&height=400&seq=cards-01&orientation=landscape',
  },
  {
    title: '喜剧搞笑',
    icon: 'ri-emotion-laugh-line',
    description: '轻松一刻，欢乐不停',
    count: '1,540+ 部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20warm%20comedy%20themed%20cinematic%20aesthetic%20with%20playful%20confetti%20and%20soft%20golden%20lighting%2C%20cheerful%20colorful%20atmosphere%2C%20film%20set%20inspired%20background%2C%20no%20people%2C%20lighthearted%20mood%2C%20clean%20composition&width=600&height=400&seq=cards-02&orientation=landscape',
  },
  {
    title: '悬疑推理',
    icon: 'ri-mist-line',
    description: '烧脑剧情，层层反转',
    count: '980+ 部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20cinematic%20scene%20with%20dramatic%20shadow%20play%20and%20warm%20dim%20lighting%2C%20film%20noir%20inspired%20aesthetic%2C%20foggy%20atmosphere%2C%20deep%20amber%20and%20sepia%20tones%2C%20suspenseful%20mood%2C%20no%20people%2C%20abstract%20geometric%20shadows&width=600&height=400&seq=cards-03&orientation=landscape',
  },
  {
    title: '科幻奇幻',
    icon: 'ri-rocket-line',
    description: '超越想象，探索未知',
    count: '1,120+ 部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20aesthetic%20with%20warm%20neon%20and%20golden%20glow%2C%20abstract%20space%20and%20galaxy%20elements%2C%20digital%20particles%2C%20clean%20futuristic%20composition%2C%20no%20people%2C%20atmospheric%20dark%20background%20with%20warm%20highlights&width=600&height=400&seq=cards-04&orientation=landscape',
  },
  {
    title: '爱情文艺',
    icon: 'ri-heart-line',
    description: '温暖治愈，心动瞬间',
    count: '1,350+ 部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20cinematic%20aesthetic%20with%20soft%20warm%20golden%20hour%20lighting%2C%20dreamy%20bokeh%20effects%2C%20gentle%20rose%20and%20amber%20tones%2C%20film%20photography%20texture%2C%20no%20people%2C%20elegant%20soft%20focus%20composition&width=600&height=400&seq=cards-05&orientation=landscape',
  },
  {
    title: '纪录纪实',
    icon: 'ri-camera-line',
    description: '真实世界，深度观察',
    count: '760+ 部',
    imageUrl: 'https://readdy.ai/api/search-image?query=Documentary%20cinematic%20aesthetic%20with%20warm%20natural%20lighting%2C%20vintage%20camera%20and%20film%20equipment%2C%20earthy%20amber%20and%20gold%20tones%2C%20authentic%20texture%2C%20no%20people%2C%20clean%20documentary-style%20composition&width=600&height=400&seq=cards-06&orientation=landscape',
  },
];

export const topics = [
  { label: '暑期档热播', count: '12.6万', hot: true },
  { label: '高分华语剧', count: '9.8万', hot: true },
  { label: '日漫新番', count: '8.3万', hot: true },
  { label: '好莱坞大片', count: '7.5万', hot: false },
  { label: '悬疑推理', count: '6.9万', hot: false },
  { label: '喜剧合家欢', count: '6.2万', hot: false },
  { label: '古装传奇', count: '5.7万', hot: false },
  { label: '科幻巨制', count: '5.1万', hot: false },
  { label: '韩剧热追', count: '4.8万', hot: false },
  { label: '综艺精选', count: '4.3万', hot: false },
  { label: '纪录片频道', count: '3.6万', hot: false },
];

export const mediaItems = [
  {
    title: '《时空迷途》科幻巨制全网首播',
    category: '电影 · 科幻',
    duration: '128分钟',
    quality: '1080P',
    views: '35.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20thumbnail%20style%20with%20warm%20golden%20and%20crimson%20lighting%2C%20abstract%20futuristic%20cityscape%2C%20dramatic%20atmosphere%2C%20film%20poster%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20widescreen%20composition&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    title: '《长安十二时辰》精编版上线',
    category: '剧集 · 古装',
    duration: '48集全',
    quality: '4K修复',
    views: '28.7万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20cityscape%20with%20warm%20lantern%20glow%20and%20golden%20rooftops%2C%20traditional%20architecture%2C%20dramatic%20evening%20lighting%2C%20film%20poster%20aesthetic%2C%20no%20people%2C%20rich%20amber%20tones&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    title: '《深海迷踪》动画电影高清版',
    category: '动漫 · 奇幻',
    duration: '96分钟',
    quality: '1080P',
    views: '22.1万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Animated%20film%20cinematic%20aesthetic%20with%20deep%20ocean%20blues%20and%20warm%20bioluminescent%20golden%20glow%2C%20fantasy%20underwater%20scene%2C%20dreamy%20atmosphere%2C%20no%20characters%2C%20rich%20contrast%20composition&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    title: '《欢乐喜剧人》第六季全集',
    category: '综艺 · 喜剧',
    duration: '12期',
    quality: '1080P',
    views: '19.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20stage%20with%20warm%20colorful%20spotlights%2C%20theatrical%20atmosphere%2C%20golden%20and%20amber%20performance%20lighting%2C%20no%20people%2C%20vibrant%20show%20aesthetic&width=640&height=360&seq=media-04&orientation=landscape',
  },
  {
    title: '《舌尖上的中国》第五季回归',
    category: '纪录 · 美食',
    duration: '8集全',
    quality: '4K超清',
    views: '41.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20food%20documentary%20aesthetic%20with%20warm%20steaming%20cuisine%20in%20soft%20golden%20window%20light%2C%20traditional%20Chinese%20kitchen%20atmosphere%2C%20rich%20texture%2C%20amber%20tones%2C%20no%20people%2C%20elegant%20food%20photography&width=640&height=360&seq=media-05&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于91免费',
  paragraphs: [
    '91免费看片网站创立于对自由观影体验的执着追求。我们深知用户在寻找高质量免费影视资源时面临的困扰——满屏广告、恶意跳转、虚假链接，这些问题严重影响了观影体验。因此，我们打造了91免费这个纯净、高效的免费看片平台，让每一位用户都能轻松找到并观看自己喜爱的内容。',
    '平台目前聚合了超过五万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等三十余个细分类别。从经典老片到最新热播，从华语内容到海外佳作，91免费致力于构建最全面的免费看片资源库。',
    '我们的技术团队持续优化平台体验，智能推荐算法根据您的观影偏好精准匹配内容，全球CDN加速确保流畅播放。91免费看片神器让移动端用户随时随地享受高清观影，真正做到"看片自由"。',
  ],
  stats: [
    { value: '50,000+', label: '影视资源' },
    { value: '30+', label: '内容分类' },
    { value: '200+', label: '每日更新' },
    { value: '99.9%', label: '服务在线率' },
  ],
  imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20home%20theater%20interior%20with%20velvet%20seats%20and%20large%20projection%20screen%2C%20soft%20ambient%20red%20and%20gold%20lighting%2C%20elegant%20modern%20design%2C%20cozy%20atmosphere%2C%20no%20people%2C%20luxurious%20private%20cinema%20aesthetic&width=700&height=500&seq=about-01&orientation=squarish',
};

export const rankingItems = [
  { rank: 1, title: '《时空迷途》', category: '科幻 / 动作', score: '9.2', trend: 'up', change: '+3' },
  { rank: 2, title: '《长安诡事录》', category: '悬疑 / 古装', score: '9.0', trend: 'up', change: '+5' },
  { rank: 3, title: '《深海迷踪》', category: '动画 / 奇幻', score: '8.9', trend: 'new', change: 'NEW' },
  { rank: 4, title: '《夏日喜剧人》', category: '综艺 / 喜剧', score: '8.7', trend: 'down', change: '-1' },
  { rank: 5, title: '《逆流时光》', category: '剧情 / 爱情', score: '8.6', trend: 'up', change: '+2' },
  { rank: 6, title: '《舌尖上的中国5》', category: '纪录 / 美食', score: '8.5', trend: 'same', change: '—' },
];

export const comments = [
  {
    name: '影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20style%20avatar%2C%20warm%20lighting%2C%20neutral%20background%2C%20clean%20minimal%20headshot%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    time: '2天前',
    content: '找了很久的免费看片平台，91免费真的惊艳到我了！资源全、更新快，最重要的是没有烦人的弹窗广告，观影体验比很多付费平台还好。已经推荐给身边所有朋友了！',
  },
  {
    name: '追剧达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20portrait%20style%20avatar%2C%20warm%20tone%2C%20simple%20background%2C%20natural%20lighting%2C%20relaxed%20expression%2C%20clean%20composition&width=80&height=80&seq=avatar-02&orientation=squarish',
    time: '3天前',
    content: '作为一个重度追剧党，91免费简直就是我的救星。热门新剧更新速度超快，画质清晰流畅，手机上看也完全不卡。看片神器名不虚传！',
  },
  {
    name: '动漫爱好者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Stylish%20portrait%20avatar%2C%20warm%20ambient%20lighting%2C%20minimal%20background%2C%20confident%20expression%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    time: '5天前',
    content: '日漫新番追更速度比一些专门动漫站还快，而且翻译质量高。分类清晰，找番超方便。唯一建议是希望增加弹幕功能，那样就更完美了。',
  },
  {
    name: '家庭观影用户王姐',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20avatar%2C%20soft%20natural%20lighting%2C%20neutral%20background%2C%20gentle%20expression%2C%20clean%20minimal%20headshot%20style&width=80&height=80&seq=avatar-04&orientation=squarish',
    time: '1周前',
    content: '周末带孩子一起在电视上看电影，投屏功能太方便了。片库里有好多适合全家一起看的合家欢电影，画质清楚，播放稳定。91免费真的帮我们省了不少去电影院的钱。',
  },
  {
    name: '纪录片迷老刘',
    avatar: 'https://readdy.ai/api/search-image?query=Mature%20professional%20portrait%20avatar%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20thoughtful%20expression%2C%20clean%20headshot%20composition&width=80&height=80&seq=avatar-05&orientation=squarish',
    time: '1周前',
    content: '作为一个纪录片爱好者，91免费的纪录片频道让我惊喜。BBC、NHK、央视的经典纪录片都能找到，而且持续更新。每天晚上看一部纪录片已经成为我的习惯。感谢平台！',
  },
];

export const indexItems = [
  { title: '2026暑期档观影指南', icon: 'ri-guide-line', count: '36篇', desc: '一站式掌握暑期热门影片' },
  { title: '豆瓣8.5+华语剧精选', icon: 'ri-star-line', count: '24篇', desc: '口碑炸裂的国产好剧' },
  { title: '日漫新番追更日历', icon: 'ri-calendar-line', count: '18篇', desc: '每周更新番剧时间表' },
  { title: '好莱坞科幻片Top50', icon: 'ri-planet-line', count: '50篇', desc: '影史经典科幻全收录' },
  { title: '悬疑推理片烧脑合集', icon: 'ri-brain-line', count: '42篇', desc: '挑战智商的推理盛宴' },
  { title: '合家欢电影推荐', icon: 'ri-group-line', count: '28篇', desc: '适合全家一起看的佳片' },
  { title: '古装剧服化道赏析', icon: 'ri-palette-line', count: '15篇', desc: '细品古装美学艺术' },
  { title: '韩剧追更必看清单', icon: 'ri-heart-pulse-line', count: '22篇', desc: '当季最热门韩剧一网打尽' },
  { title: '纪录片频道精选', icon: 'ri-earth-line', count: '33篇', desc: '探索世界的真实故事' },
];

export const updateItems = [
  {
    date: '2026-07-29',
    tag: '新片上线',
    title: '《时空迷途》高清版正式登陆91免费平台',
    description: '年度科幻巨制《时空迷途》高清完整版现已上线，支持1080P画质播放，中英双语字幕可选。',
  },
  {
    date: '2026-07-28',
    tag: '功能更新',
    title: '移动端播放器全面升级，支持手势控制',
    description: '91免费看片神器移动端播放器新增手势音量调节、亮度控制和双击快进功能，观影更便捷。',
  },
  {
    date: '2026-07-27',
    tag: '专题上线',
    title: '「暑期档观影指南」专题页面发布',
    description: '精心策划的暑期档观影专题上线，涵盖动作、喜剧、动画等热门类型，一站看遍暑期好片。',
  },
  {
    date: '2026-07-26',
    tag: '片库扩充',
    title: '纪录片频道新增300+部优质内容',
    description: '引进BBC、国家地理等知名厂牌纪录片资源，覆盖自然、历史、科技、美食等多元题材。',
  },
  {
    date: '2026-07-25',
    tag: '新片上线',
    title: '《长安诡事录》全集上线，悬疑古装热播中',
    description: '古装悬疑剧《长安诡事录》全集48集已更新完毕，豆瓣开分8.8，口碑持续走高。',
  },
  {
    date: '2026-07-24',
    tag: '系统优化',
    title: 'CDN加速节点扩增至全球36个区域',
    description: '新增东南亚与欧洲加速节点，海外用户观影体验大幅提升，加载速度平均提升40%。',
  },
  {
    date: '2026-07-23',
    tag: '内容合作',
    title: '与多家正版内容方达成资源合作',
    description: '持续拓展优质内容来源，为用户提供更丰富、更高质量的免费看片资源选择。',
  },
];

export const contactData = {
  title: '联系我们',
  subtitle: '意见反馈 · 内容建议 · 合作咨询',
  description: '如果您在使用91免费看片平台过程中遇到任何问题，或有内容推荐、合作意向，欢迎通过以下方式与我们取得联系。我们重视每一条用户反馈，并持续优化您的观影体验。',
  email: 'feedback@91free.example.com',
  wechat: '91free_official',
  qq: '800123456',
};

export const footerLinks = {
  sections: [
    {
      title: '快速导航',
      links: [
        { label: '热门推荐', href: '#carousel' },
        { label: '平台优势', href: '#features' },
        { label: '常见问题', href: '#faq' },
        { label: '关于我们', href: '#about' },
        { label: '联系我们', href: '#contact' },
      ],
    },
    {
      title: '内容分类',
      links: [
        { label: '电影', href: '#cards' },
        { label: '电视剧', href: '#cards' },
        { label: '综艺', href: '#cards' },
        { label: '动漫', href: '#cards' },
        { label: '纪录片', href: '#cards' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '使用指南', href: '#faq' },
        { label: '播放问题', href: '#faq' },
        { label: '反馈建议', href: '#contact' },
        { label: '用户口碑', href: '#comments' },
        { label: '最新动态', href: '#updates' },
      ],
    },
  ],
};

export const footerAbout = '91免费看片网站致力于为用户提供纯净、高效的免费观影体验。平台聚合海量影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型，每日更新，全终端适配。无需付费、无需注册，打开即看。91免费看片神器让您随时随地畅享高清观影乐趣。';